import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { colors } from '@styles/colors';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export default function AdminMenuItem({ to, icon, children, radius = '1.2vh', bg = 'transparent', fontWeight }) {
  const location = useLocation();
  const isActive = location.pathname.startsWith(to) && to !== '/' || (to === '/' && location.pathname === '/');

  return (
    <Link
      to={to}
      style={{
        textDecoration: 'none',
        color: isActive ? colors.primaryText : colors.gray700,
        fontFamily: 'Inter',
        fontSize: '1.9vh',
        fontWeight: isActive ? '700' : fontWeight,
        padding: '1.0vh 1.5vh',
        backgroundColor: isActive ? colors.verdeClaro : bg,
        borderRadius: radius,
        border: '0.1vh solid transparent',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '0.8vh',
        width: '100%',
        boxSizing: 'border-box',
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => {
        if (!isActive) {
          e.currentTarget.style.backgroundColor = colors.gray200;
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.currentTarget.style.backgroundColor = bg;
        }
      }}
    >
      {React.cloneElement(icon, { style: { ...icon.props.style, color: isActive ? colors.primaryText : colors.gray700 } })}
      {children}
      <ChevronRightIcon style={{ marginLeft: 'auto', color: isActive ? colors.primaryText : colors.gray700 }} />
    </Link>
  );
}